import { render, staticRenderFns } from "./MatchupTypeBlock.vue?vue&type=template&id=541ddfea"
import script from "./MatchupTypeBlock.vue?vue&type=script&lang=ts"
export * from "./MatchupTypeBlock.vue?vue&type=script&lang=ts"
import style0 from "./MatchupTypeBlock.vue?vue&type=style&index=0&id=541ddfea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports